import { render, staticRenderFns } from "./ReviewAndSend.vue?vue&type=template&id=7080a136&"
import script from "./ReviewAndSend.vue?vue&type=script&lang=js&"
export * from "./ReviewAndSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports